import $ from 'jquery';
import _ from 'underscore';
import Numeral from 'numeral';
import Cache from 'root/cache';
import Constants from 'root/constants';
import UI from 'root/ui';
import Svg_Icon from 'root/module/svg_icon';
import View from 'view/base';

var Account_Upgrade_Plan_Select_2024 = View.extend({
    className: 'account-upgrade-plan-select',

    billing_interval: Constants.ANNUALLY,
    plan_type: Constants.PLAN_2024_SCALE_A,

    is_upgrade: false,

    events: {
        'click .billing-cycle-selection > span' : 'selectBillingCycle',
        'mousedown .user-limit-add'             : 'adjustUserLimit',
        'mousedown .user-limit-delete'          : 'adjustUserLimit',
        'mouseleave .user-limit-add'            : 'mouseLeaveUserLimit',
        'mouseleave .user-limit-delete'         : 'mouseLeaveUserLimit',
        'mouseup .user-limit-add'               : 'mouseLeaveUserLimit',
        'mouseup .user-limit-delete'            : 'mouseLeaveUserLimit',
        'click .dropdown-response-limit li'     : 'selectResponseLimit',
        'click .dropdown-session-limit li'      : 'selectSessionLimit',
        'click .feature-compare'                : 'compreFeatures',
        'click .plan-continue'                  : 'continue',
        'click .lets-talk'                      : 'letsTalk'
    },

    dom_handlers: {
        selectBillingCycle: function(e) {
            if ($(e.currentTarget).hasClass('active')) {
                return;
            }

            if (this.billing_interval === Constants.MONTHLY) {
                this.billing_interval = Constants.ANNUALLY;

                this.$el.find('.billing-cycle-selection > span:first').removeClass('active');
                this.$el.find('.billing-cycle-selection > span:last').addClass('active');
            } else {
                this.billing_interval = Constants.MONTHLY;

                this.$el.find('.billing-cycle-selection > span:first').addClass('active');
                this.$el.find('.billing-cycle-selection > span:last').removeClass('active');
            }

            this.updatePrice();
        },

        mouseLeaveUserLimit: function(e) {
            clearTimeout(this.user_limit_mouse_timeout);
            this.user_limit_mouse_timeout = null;
        },

        adjustUserLimit: function(e) {
            var is_add       = $(e.currentTarget).hasClass('user-limit-add');
            var element      = $(e.currentTarget).parents('.account-plan').find('.user-limit');
            var plan_type    = $(e.currentTarget).parents('.account-plan').data('type');
            var included_num = Cache.account.getUserLimit(plan_type, false);

            var user_limit = parseInt(element.text(), 10);

            if (is_add) {
                user_limit++;
            } else {
                user_limit--;
            }

            user_limit = Math.max(user_limit, included_num);
            user_limit = Math.min(user_limit, 1000);

            element.text(user_limit);

            $(e.currentTarget).parents('.account-plan').find('.user-limit-delete').prop('disabled', user_limit <= included_num);

            var is_first_click = this.user_limit_mouse_timeout ? false : true;

            this.user_limit_mouse_timeout = setTimeout(() => {
                $(e.currentTarget).trigger('mousedown');
            }, is_first_click ? 400 : 100);

            this.updatePrice();
        },

        selectResponseLimit: function(e) {
            var response_limit = parseInt($(e.currentTarget).data('val'), 10);

            $(e.currentTarget).parents('.button-dropdown').find('.response-limit').text(Numeral(response_limit).format('0,0'));

            $(e.currentTarget).parent().find('li.selected').removeClass('selected');
            $(e.currentTarget).addClass('selected');

            this.updatePrice();
        },

        selectSessionLimit: function(e) {
            var session_limit = parseInt($(e.currentTarget).data('val'), 10);

            $(e.currentTarget).parents('.button-dropdown').find('.session-limit').text(Numeral(session_limit).format('0,0'));

            $(e.currentTarget).parent().find('li.selected').removeClass('selected');
            $(e.currentTarget).addClass('selected');

            this.updatePrice();
        },

        compreFeatures: function(e) {
            this.$el.find('.feature-compare + div').toggle();
            this.$el.find('.feature-all').toggle();
        },

        letsTalk: function(e) {
            e.preventDefault();
            UI.openLiveChat();
        },

        continue: function(e) {
            var plan_container = $(e.currentTarget).parents('.account-plan');
            var plan_type      = parseInt($(e.currentTarget).parents('.account-plan').data('type'), 10);
            var response_limit = parseInt(plan_container.find('.response-limit').text().replace(/,/g, ''), 10);
            var session_limit  = parseInt(plan_container.find('.session-limit').text().replace(/,/g, ''), 10);
            var extra_user     = 0;

            if (plan_type === Constants.PLAN_2024_CUSTOM && !this.hasCustom()) {
                return;
            }

            if (plan_type === Constants.PLAN_2024_STARTER_A || plan_type === Constants.PLAN_2024_SCALE_A) {
                extra_user = parseInt(plan_container.find('.user-limit').text(), 10) - Cache.account.getUserLimit(plan_type, false);
            }

            if (this.plan_type === Constants.PLAN_2024_CUSTOM) {
                if (Cache.account.get('premium_monthly_price') && Cache.account.get('premium_annual_price')) {

                } else if (Cache.account.get('premium_monthly_price')) {
                    this.billing_interval = Constants.MONTHLY;
                } else if (Cache.account.get('premium_annual_price')) {
                    this.billing_interval = Constants.ANNUALLY;
                }
            }

            this.trigger('continue', {
                billing_interval : this.billing_interval,
                plan_type        : plan_type,
                extra_user       : extra_user,
                response_limit   : response_limit,
                session_limit    : session_limit
            });
        }
    },

    updatePrice: function() {
        var plan_container_starter   = this.$el.find('.account-plan[data-type="' + Constants.PLAN_2024_STARTER + '"]');
        var plan_container_scale     = this.$el.find('.account-plan[data-type="' + Constants.PLAN_2024_SCALE + '"]');
        var plan_container_starter_a = this.$el.find('.account-plan[data-type="' + Constants.PLAN_2024_STARTER_A + '"]');
        var plan_container_scale_a   = this.$el.find('.account-plan[data-type="' + Constants.PLAN_2024_SCALE_A + '"]');

        var extra_user_start_a = parseInt(plan_container_starter_a.find('.user-limit').text(), 10) - Cache.account.getUserLimit(Constants.PLAN_2024_STARTER_A, false);
        var extra_user_scale_a = parseInt(plan_container_scale_a.find('.user-limit').text(), 10) - Cache.account.getUserLimit(Constants.PLAN_2024_SCALE_A, false);

        var response_limit_starter = parseInt(plan_container_starter.find('.response-limit').text().replace(/,/g, ''), 10);
        var session_limit_starter = parseInt(plan_container_starter.find('.session-limit').text().replace(/,/g, ''), 10);

        var response_limit_scale = parseInt(plan_container_scale.find('.response-limit').text().replace(/,/g, ''), 10);
        var session_limit_scale = parseInt(plan_container_scale.find('.session-limit').text().replace(/,/g, ''), 10);

        var response_limit_starter_a = parseInt(plan_container_starter_a.find('.response-limit').text().replace(/,/g, ''), 10);
        var session_limit_starter_a = parseInt(plan_container_starter_a.find('.session-limit').text().replace(/,/g, ''), 10);

        var response_limit_scale_a = parseInt(plan_container_scale_a.find('.response-limit').text().replace(/,/g, ''), 10);
        var session_limit_scale_a = parseInt(plan_container_scale_a.find('.session-limit').text().replace(/,/g, ''), 10);

        plan_container_starter.find('.price .number').text(Numeral(Cache.account.getPrice(Constants.PLAN_2024_STARTER, this.billing_interval, 0, 0, session_limit_starter, response_limit_starter)).format(','));
        plan_container_scale.find('.price .number').text(Numeral(Cache.account.getPrice(Constants.PLAN_2024_SCALE, this.billing_interval, 0, 0, session_limit_scale, response_limit_scale)).format(','));
        plan_container_starter_a.find('.price .number').text(Numeral(Cache.account.getPrice(Constants.PLAN_2024_STARTER_A, this.billing_interval, 0, extra_user_start_a, session_limit_starter_a, response_limit_starter_a)).format(','));
        plan_container_scale_a.find('.price .number').text(Numeral(Cache.account.getPrice(Constants.PLAN_2024_SCALE_A, this.billing_interval, 0, extra_user_scale_a, session_limit_scale_a, response_limit_scale_a)).format(','));

        if (this.hasCustom()) {
            if ((Cache.account.get('premium_monthly_price') && this.billing_interval === Constants.MONTHLY) ||
                (Cache.account.get('premium_monthly_price') && !Cache.account.get('premium_annual_price'))) {
                this.$el.find('.account-plan[data-type="' + Constants.PLAN_2024_CUSTOM + '"]').find('.price .number').text(Cache.account.getPrice(Constants.PLAN_2024_CUSTOM, this.billing_interval));
                this.$el.find('.account-plan[data-type="' + Constants.PLAN_2024_CUSTOM + '"]').find('.price .unit').text('/ month');
            } else {
                this.$el.find('.account-plan[data-type="' + Constants.PLAN_2024_CUSTOM + '"]').find('.price .number').text(Cache.account.getPrice(Constants.PLAN_2024_CUSTOM, this.billing_interval) * 12);
                this.$el.find('.account-plan[data-type="' + Constants.PLAN_2024_CUSTOM + '"]').find('.price .unit').text('/ year');
            }
        } else {
            if (this.billing_interval === Constants.MONTHLY) {
                this.$el.find('.account-plan[data-type="' + Constants.PLAN_2024_CUSTOM + '"]').find('.price .number').text(289);
                this.$el.find('.account-plan[data-type="' + Constants.PLAN_2024_CUSTOM + '"]').find('.price .unit').text('/ month');
            } else {
                this.$el.find('.account-plan[data-type="' + Constants.PLAN_2024_CUSTOM + '"]').find('.price .number').text(219);
                this.$el.find('.account-plan[data-type="' + Constants.PLAN_2024_CUSTOM + '"]').find('.price .unit').text('/ month');
            }
        }
    },

    setBillingCycle: function(billing_interval) {
        this.billing_interval = parseInt(billing_interval, 10);
    },

    hasCustom: function() {
        return Cache.account.get('premium_monthly_price') || Cache.account.get('premium_annual_price') ? true : false;
    },

    initialize: function(options) {
        this.is_upgrade = Cache.account.get('is_trial') || Cache.account.get('is_expired') || (Cache.account.get('appsumo') && !Cache.account.get('credit_card_digit'));

        if (this.is_upgrade) {
            if (Cache.account.get('discount_plan_type')) {
                // default to the discounted billing interval
                this.billing_interval = Cache.account.get('discount_plan_type');
            }

            if (Cache.account.get('appsumo')) {
                this.plan_type = Cache.account.get('plan');
            }
        } else {
            // change plan
            this.billing_interval = Cache.account.get('billing_interval');
            this.plan_type        = Cache.account.get('plan');
        }
    },

    isPricing2024_A: function() {
        return this.plan_type === Constants.PLAN_2024_STARTER_A || this.plan_type === Constants.PLAN_2024_SCALE_A;
    },

    setOptions: function(options) {
        this.billing_interval = options.billing_interval;
        this.plan_type        = options.plan_type;
    },

    choosePlan: function(plan_type) {
        this.$el.find('.account-plan[data-type="' + plan_type + '"]').click();
    },

    continue: function() {
        this.$el.find('.account-plan[data-type="' + this.plan_type + '"]').find('.plan-continue').click();
    },

    render: function() {
        var response_limit_options = {
            [Constants.PLAN_2024_STARTER]: '',
            [Constants.PLAN_2024_SCALE]: '',
            [Constants.PLAN_2024_STARTER_A]: '',
            [Constants.PLAN_2024_SCALE_A]: ''
        };
        var session_limit_options = {
            [Constants.PLAN_2024_STARTER]: '',
            [Constants.PLAN_2024_SCALE]: '',
            [Constants.PLAN_2024_STARTER_A]: '',
            [Constants.PLAN_2024_SCALE_A]: ''
        };

        _.each(response_limit_options, (value, key) => {
            Cache.account.getResponseLimitOptions(key).forEach((limit) => {
                response_limit_options[key] += '<li data-val="' + limit + '">' + Numeral(limit).format('0,0') + '</li>';
            });
        });

        _.each(session_limit_options, (value, key) => {
            Cache.account.getSessionLimitOptions(key).forEach((limit) => {
                session_limit_options[key] += '<li data-val="' + limit + '">' + Numeral(limit).format('0,0')  + '</li>';
            });
        });

        var content = '';

        content += '<div class="account-plan-main">';

        content += '<div class="account-plan-container">' +
                        '<div class="account-plan-billing-cycle-selection">' +
                            '<div class="billing-cycle-selection badge-group-tertiary">' +
                                '<span' + ((this.billing_interval === Constants.MONTHLY  ? ' class="active"' : '')) + '>Monthly</span>' +
                                '<span' + ((this.billing_interval === Constants.ANNUALLY ? ' class="active"' : '')) + '>Yearly<span class="yearly-discount">Save 25%</span></span>' +
                            '</div>' +
                        '</div>' +

                        '<div class="account-plan-grid-container account-plan-grid-container-small">' +

                            // starter
                            (this.isPricing2024_A() ? '' :
                            '<div>' +
                                '<div class="account-plan account-plan-2024" data-type="' + Constants.PLAN_2024_STARTER + '">' +
                                    '<div class="checkmark">' + Svg_Icon.tick + '</div>' +
                                    '<div class="title text-success">' + Cache.account.getPlanName(Constants.PLAN_2024_STARTER) + '</div>' +
                                    '<div class="price">' +
                                        '<span class="dollar">$</span>' +
                                        '<span class="number"></span>' +
                                        '<span class="unit">/ month</span>' +
                                    '</div>' +
                                    '<div class="feature-list">' +
                                        '<div class="feature-limit feature-limit-short">' +
                                            /*
                                            '<div class="button-dropdown button-dropdown-left">' +
                                                '<button type="button" class="dropdown-select"><span class="response-limit"></span></button>' +
                                                '<div>' +
                                                    '<ul class="dropdown dropdown-select dropdown-response-limit">' +
                                                        response_limit_options[Constants.PLAN_2024_STARTER] +
                                                    '</ul>' +
                                                '</div>' +
                                            '</div>' +
                                            '<div>feedback & survey responses</div>' +
                                            */
                                            '<div class="button-dropdown button-dropdown-left">' +
                                                '<button type="button" class="dropdown-select"><span class="session-limit"></span></button>' +
                                                '<div>' +
                                                    '<ul class="dropdown dropdown-select dropdown-session-limit">' +
                                                        session_limit_options[Constants.PLAN_2024_STARTER] +
                                                    '</ul>' +
                                                '</div>' +
                                            '</div>' +
                                            '<div>session replays</div>' +
                                        '</div>' +
                                        '<div class="feature-select">' +
                                            '<button type="button" class="plan-continue primary medium full">Continue</button>' +
                                        '</div>' +
                                        '<div class="feature-key">' +
                                            '<ul class="short">' +
                                                '<li><b>Unlimited</b> Seats</li>' +
                                                '<li><b>Unlimited</b> Feedback</li>' +
                                            '</ul>' +
                                            '<div class="feature-compare hr"><span>Compare <i class="fa-solid fa-chevron-down"></i></span></div>' +
                                            '<div>' +
                                                '<b>Includes:</b>' +
                                                '<ul class="long">' +
                                                    '<li>In-App Surveys <span class="badge-primary-invert badge-small badge-round vbadge-round font-weight-medium">New</span></li>' +
                                                    '<li>Feedback Widgets & Templates</li>' +
                                                    '<li>Session Replays <span class="badge-primary-invert badge-small badge-round badge-round font-weight-medium">Popular</span></li>' +
                                                    '<li>Feature Portal</li>' +
                                                    '<li>Annotated Screenshots</li>' +
                                                    '<li>Video Recordings</li>' +
                                                    '<li>Survey and Feedback Triggers</li>' +
                                                    '<li>Feedback Automation</li>' +
                                                    '<li>Integrations inc. Jira, Slack & 16+ more </li>' +
                                                    '<li>User Identification & Segments <span class="badge-primary-invert badge-small badge-round font-weight-medium">New</span></li>' +
                                                '</ul>' +
                                            '</div>' +
                                        '</div>' +
                                        '<div class="feature-all" style="display:none;"><a href="https://userback.io/legacy-pricing-a/" target="help" rel="noopener">See all the features<i class="fas fa-external-link-alt margin-left-4"></i></a></div>' +
                                    '</div>' +
                                '</div>' +
                            '</div>') +

                            // scale
                            (this.isPricing2024_A() ? '' :
                            '<div>' +
                                '<div class="account-plan account-plan-2024" data-type="' + Constants.PLAN_2024_SCALE + '">' +
                                    '<div class="checkmark">' + Svg_Icon.tick + '</div>' +
                                    '<div class="title text-dolphin">' + (Cache.account.get('appsumo') ? 'LTD' : Cache.account.getPlanName(Constants.PLAN_2024_SCALE)) + '</div>' +
                                    '<div class="price">' +
                                        '<span class="dollar">$</span>' +
                                        '<span class="number"></span>' +
                                        '<span class="unit">/ month</span>' +
                                    '</div>' +
                                    '<div class="feature-list">' +
                                        '<div class="feature-limit feature-limit-short">' +
                                            /*
                                            '<div class="button-dropdown button-dropdown-left">' +
                                                '<button type="button" class="dropdown-select"><span class="response-limit"></span></button>' +
                                                '<div>' +
                                                    '<ul class="dropdown dropdown-select dropdown-response-limit">' +
                                                        response_limit_options[Constants.PLAN_2024_SCALE] +
                                                    '</ul>' +
                                                '</div>' +
                                            '</div>' +
                                            '<div>feedback & survey responses</div>' +
                                            */
                                            '<div class="button-dropdown button-dropdown-left">' +
                                                '<button type="button" class="dropdown-select"><span class="session-limit"></span></button>' +
                                                '<div>' +
                                                    '<ul class="dropdown dropdown-select dropdown-session-limit">' +
                                                        session_limit_options[Constants.PLAN_2024_SCALE] +
                                                    '</ul>' +
                                                '</div>' +
                                            '</div>' +
                                            '<div>session replays</div>' +
                                        '</div>' +
                                        '<div class="feature-select">' +
                                            '<button type="button" class="plan-continue primary medium full">Continue</button>' +
                                        '</div>' +
                                        '<div class="feature-key">' +
                                            '<ul class="short">' +
                                                '<li><b>Unlimited</b> Seats</li>' +
                                                '<li><b>Unlimited</b> Feedback</li>' +
                                            '</ul>' +
                                            '<div class="feature-compare hr"><span>Compare <i class="fa-solid fa-chevron-down"></i></span></div>' +
                                            '<div>' +
                                                '<b>Everything in Starter, and:</b>' +
                                                '<ul class="long">' +
                                                    (Cache.account.get('appsumo') ? '' :
                                                    '<li>AI Assist <span class="badge-primary-invert badge-small badge-round font-weight-medium">New</span></li>') +
                                                    '<li>Console Logs</li>' +
                                                    '<li>Private Feature Portal</li>' +
                                                    '<li>Advanced Survey Triggers</li>' +
                                                    '<li>Conditional Survey Questions <span class="badge-primary-invert badge-small badge-round font-weight-medium">Coming soon</span></li>' +
                                                    '<li>Survey Question Randomization</li>' +
                                                    '<li>Custom Branding</li>' +
                                                    '<li>Remove "Powered by Userback"</li>' +
                                                    '<li>Custom Data Collection</li>' +
                                                    (Cache.account.get('appsumo') ? '' :
                                                    '<li>Email Forwarding <span class="badge-primary-invert badge-small badge-round font-weight-medium">New</span></li>') +
                                                    '<li>Webhooks to Connect Other Solutions</li>' +
                                                '</ul>' +
                                            '</div>' +
                                        '</div>' +
                                        '<div class="feature-all" style="display:none;"><a href="https://userback.io/legacy-pricing-a/" target="help" rel="noopener">See all the features<i class="fas fa-external-link-alt margin-left-4"></i></a></div>' +
                                    '</div>' +
                                '</div>' +
                            '</div>') +

                            // starter A
                            (this.isPricing2024_A() ?
                            '<div>' +
                                '<div class="account-plan account-plan-2024" data-type="' + Constants.PLAN_2024_STARTER_A + '">' +
                                    '<div class="checkmark">' + Svg_Icon.tick + '</div>' +
                                    '<div class="title text-success">' + Cache.account.getPlanName(Constants.PLAN_2024_STARTER_A) + '</div>' +
                                    '<div class="price">' +
                                        '<span class="dollar">$</span>' +
                                        '<span class="number"></span>' +
                                        '<span class="unit">/ month</span>' +
                                    '</div>' +
                                    '<div class="feature-list">' +
                                        '<div class="feature-limit">' +
                                            '<div>' +
                                                '<div class="flex-start">' +
                                                    '<div class="user-limit">' + Cache.account.getUserLimit(Constants.PLAN_2024_STARTER_A, false) + '</div>' +
                                                    '<div>' +
                                                        '<button type="button" class="user-limit-add"><i class="fa-solid fa-plus"></i></button>' +
                                                        '<button type="button" class="user-limit-delete" disabled><i class="fa-solid fa-minus"></i></button>' +
                                                    '</div>' +
                                                '</div>' +
                                                '<div>seats</div>' +
                                            '</div>' +
                                            /*
                                            '<div class="button-dropdown button-dropdown-left">' +
                                                '<button type="button" class="dropdown-select"><span class="response-limit"></span></button>' +
                                                '<div>' +
                                                    '<ul class="dropdown dropdown-select dropdown-response-limit">' +
                                                        response_limit_options[Constants.PLAN_2024_STARTER_A] +
                                                    '</ul>' +
                                                '</div>' +
                                            '</div>' +
                                            '<div>feedback & survey responses</div>' +
                                            */
                                            '<div class="button-dropdown button-dropdown-left">' +
                                                '<button type="button" class="dropdown-select"><span class="session-limit"></span></button>' +
                                                '<div>' +
                                                    '<ul class="dropdown dropdown-select dropdown-session-limit">' +
                                                        session_limit_options[Constants.PLAN_2024_STARTER_A] +
                                                    '</ul>' +
                                                '</div>' +
                                            '</div>' +
                                            '<div>session replays</div>' +
                                        '</div>' +
                                        '<div class="feature-select">' +
                                            '<button type="button" class="plan-continue primary medium full">Continue</button>' +
                                        '</div>' +
                                        '<div class="feature-key">' +
                                            '<ul class="short">' +
                                                '<li><b>Unlimited</b> Projects</li>' +
                                                '<li><b>Unlimited</b> Feedback</li>' +
                                            '</ul>' +
                                            '<div class="feature-compare hr"><span>Compare <i class="fa-solid fa-chevron-down"></i></span></div>' +
                                            '<div>' +
                                                '<b>Includes:</b>' +
                                                '<ul class="long">' +
                                                    '<li>In-App Surveys <span class="badge-primary-invert badge-small badge-round font-weight-medium">New</span></li>' +
                                                    '<li>Feedback Widgets & Templates</li>' +
                                                    '<li>Session Replays <span class="badge-primary-invert badge-small badge-round font-weight-medium">Popular</span></li>' +
                                                    '<li>Feature Portal</li>' +
                                                    '<li>Annotated Screenshots</li>' +
                                                    '<li>Video Recordings</li>' +
                                                    '<li>Survey and Feedback Triggers</li>' +
                                                    '<li>Feedback Automation</li>' +
                                                    '<li>Integrations inc. Jira, Slack & 16+ more </li>' +
                                                    '<li>User Identification & Segments <span class="badge-primary-invert badge-small badge-round font-weight-medium">New</span></li>' +
                                                '</ul>' +
                                            '</div>' +
                                        '</div>' +
                                        '<div class="feature-all"><a href="https://userback.io/legacy-pricing-a/" target="help" rel="noopener">See all the features<i class="fas fa-external-link-alt margin-left-4"></i></a></div>' +
                                    '</div>' +
                                '</div>' +
                            '</div>' : '') +

                            // scale A
                            (this.isPricing2024_A() ?
                            '<div>' +
                                '<div class="account-plan account-plan-2024" data-type="' + Constants.PLAN_2024_SCALE_A + '">' +
                                    '<div class="checkmark">' + Svg_Icon.tick + '</div>' +
                                    '<div class="title text-dolphin">' + (Cache.account.get('appsumo') ? 'LTD' : Cache.account.getPlanName(Constants.PLAN_2024_SCALE_A)) + '</div>' +
                                    '<div class="price">' +
                                        '<span class="dollar">$</span>' +
                                        '<span class="number"></span>' +
                                        '<span class="unit">/ month</span>' +
                                    '</div>' +
                                    '<div class="feature-list">' +
                                        '<div class="feature-limit">' +
                                            '<div>' +
                                                '<div class="flex-start">' +
                                                    '<div class="user-limit">' + Cache.account.getUserLimit(Constants.PLAN_2024_SCALE_A, false) + '</div>' +
                                                    '<div>' +
                                                        '<button type="button" class="user-limit-add"><i class="fa-solid fa-plus"></i></button>' +
                                                        '<button type="button" class="user-limit-delete" disabled><i class="fa-solid fa-minus"></i></button>' +
                                                    '</div>' +
                                                '</div>' +
                                                '<div>seats</div>' +
                                            '</div>' +
                                            /*
                                            '<div class="button-dropdown button-dropdown-left">' +
                                                '<button type="button" class="dropdown-select"><span class="response-limit"></span></button>' +
                                                '<div>' +
                                                    '<ul class="dropdown dropdown-select dropdown-response-limit">' +
                                                        response_limit_options[Constants.PLAN_2024_SCALE_A] +
                                                    '</ul>' +
                                                '</div>' +
                                            '</div>' +
                                            '<div>feedback & survey responses</div>' +
                                            */
                                            '<div class="button-dropdown button-dropdown-left">' +
                                                '<button type="button" class="dropdown-select"><span class="session-limit"></span></button>' +
                                                '<div>' +
                                                    '<ul class="dropdown dropdown-select dropdown-session-limit">' +
                                                        session_limit_options[Constants.PLAN_2024_SCALE_A] +
                                                    '</ul>' +
                                                '</div>' +
                                            '</div>' +
                                            '<div>session replays</div>' +
                                        '</div>' +
                                        '<div class="feature-select">' +
                                            '<button type="button" class="plan-continue primary medium full">Continue</button>' +
                                        '</div>' +
                                        '<div class="feature-key">' +
                                            '<ul class="short">' +
                                                '<li><b>Unlimited</b> Projects</li>' +
                                                '<li><b>Unlimited</b> Feedback</li>' +
                                            '</ul>' +
                                            '<div class="feature-compare hr"><span>Compare <i class="fa-solid fa-chevron-down"></i></span></div>' +
                                            '<div>' +
                                                '<b>Everything in Starter, and:</b>' +
                                                '<ul class="long">' +
                                                    (Cache.account.get('appsumo') ? '' :
                                                    '<li>AI Assist <span class="badge-primary-invert badge-small badge-round font-weight-medium">New</span></li>') +
                                                    '<li>Console Logs</li>' +
                                                    '<li>Private Feature Portal</li>' +
                                                    '<li>Advanced Survey Triggers</li>' +
                                                    '<li>Conditional Survey Questions <span class="badge-primary-invert badge-small badge-round font-weight-medium">Coming soon</span></li>' +
                                                    '<li>Survey Question Randomization</li>' +
                                                    '<li>Custom Branding</li>' +
                                                    '<li>Remove "Powered by Userback"</li>' +
                                                    '<li>Custom Data Collection</li>' +
                                                    (Cache.account.get('appsumo') ? '' :
                                                    '<li>Email Forwarding <span class="badge-primary-invert badge-small badge-round font-weight-medium">New</span></li>') +
                                                    '<li>Webhooks to Connect Other Solutions</li>' +
                                                '</ul>' +
                                            '</div>' +
                                        '</div>' +
                                        '<div class="feature-all"><a href="https://userback.io/legacy-pricing-a/" target="help" rel="noopener">See all the features<i class="fas fa-external-link-alt margin-left-4"></i></a></div>' +
                                    '</div>' +
                                '</div>' +
                            '</div>' : '') +

                            // custom
                            '<div>' +
                                '<div class="account-plan account-plan-2024" data-type="' + Constants.PLAN_2024_CUSTOM + '">' +
                                    '<div class="checkmark">' + Svg_Icon.tick + '</div>' +
                                    '<div class="title">' + Cache.account.getPlanName(Constants.PLAN_2024_CUSTOM) +'</div>' +
                                    '<div class="price">' +
                                        '<span class="dollar">$</span>' +
                                        '<span class="number"></span>' +
                                        '<span class="unit">/ month</span>' +
                                    '</div>' +
                                    '<div class="feature-list">' +
                                        '<div class="feature-limit' + (this.isPricing2024_A() ? '' : ' feature-limit-short') +'">' +
                                            (this.hasCustom() ?
                                            (this.isPricing2024_A() ?
                                            '<div><div class="user-limit">' + Numeral(Cache.account.get('premium_user_limit')).format(',') + '</div><div>seats</div></div>' : '') +
                                            //'<div><div class="response-limit">' + Numeral(Cache.account.get('premium_response_limit')).format(',') + '</div><div>feedback & survey responses</div></div>' +
                                            '<div><div class="session-limit">' + Numeral(Cache.account.get('premium_session_limit')).format(',') + '</div><div>session replays</div></div>' :

                                            (this.isPricing2024_A() ?
                                            '<div>Up to <b><i class="fa-solid fa-infinity"></i></b> seats</div>' : '') +
                                            //'<div>Up to <b><i class="fa-solid fa-infinity"></i></b> feedback & survey responses</div>' +
                                            '<div>Up to <b><i class="fa-solid fa-infinity"></i></b> session replays</div>') +
                                        '</div>' +
                                        '<div class="feature-select">' +
                                            (this.hasCustom() ?
                                            '<button type="button" class="plan-continue primary medium full">Continue</button>' :
                                            '<button type="button" class="lets-talk primary medium full">Let\'s Chat</button>') +
                                        '</div>' +
                                        '<div class="feature-key">' +
                                            '<ul class="short">' +
                                                (this.isPricing2024_A() ?
                                                '<li><b>Unlimited</b> Projects</li>' :
                                                '<li><b>Unlimited</b> Seats</li>') +
                                                '<li><b>Unlimited</b> Feedback</li>' +
                                            '</ul>' +
                                            '<div class="feature-compare hr"><span>Compare <i class="fa-solid fa-chevron-down"></i></span></div>' +
                                            '<div>' +
                                                '<b>Everything in Scale, and:</b>' +
                                                '<ul class="long">' +
                                                    '<li>Implementation Support</li>' +
                                                    '<li>Premium Support</li>' +
                                                    '<li>Invoice Payment</li>' +
                                                    '<li>SSO</li>' +
                                                    '<li>SOC2 Type 2 Report</li>' +
                                                '</ul>' +
                                            '</div>' +
                                        '</div>' +
                                        '<div class="feature-all" style="display:none;"><a href="https://userback.io/legacy-pricing-a/" target="help" rel="noopener">See all the features<i class="fas fa-external-link-alt margin-left-4"></i></a></div>' +
                                    '</div>' +
                                '</div>' +
                            '</div>' +

                        '</div>' +

                        '<div class="text-align-center text-info margin-top-32">All currency is in USD. </div>' +

                        (this.hasCustom() ? '' :
                        '<div class="text-align-center text-info margin-top-16">Tailor a custom plan to suit your needs. <a href="#" class="text-info lets-talk">Let\'s talk</a>.</div>') +
                    '</div>';

        content += '</div>';

        this.$el.html(content);

        // included limits
        this.$el.find('.account-plan').each(function() {
            $(this).find('.dropdown-response-limit li:first').click();
            $(this).find('.dropdown-session-limit li:first').click();
        });

        if (!this.is_upgrade) {
            var plan_container = this.$el.find('.account-plan[data-type="' + Cache.account.get('plan') + '"]');

            plan_container.addClass('account-plan-myplan');

            // set user limit
            plan_container.find('.user-limit').text(Cache.account.getUserLimit(Cache.account.get('plan')));

            if (Cache.account.get('extra_user') > 0) {
                plan_container.find('.user-limit-delete').prop('disabled', false);
            }

            // select response limit
            plan_container.find('.dropdown-response-limit li[data-val="' + Cache.account.get('response_limit') + '"]').click();

            // select session limit
            plan_container.find('.dropdown-session-limit li[data-val="' + Cache.account.get('session_limit') + '"]').click();
        }

        if (Cache.account.get('appsumo')) {
            this.$el.find('.account-plan').addClass('account-plan-disabled');
            this.$el.find('.account-plan[data-type="' + this.plan_type + '"]').removeClass('account-plan-disabled');
        }

        this.updatePrice();

        return this;
    }
});

export default Account_Upgrade_Plan_Select_2024;
